import React from 'react';
import Title from '../shared-components/Title';
import styles from './Projects.module.css';
import Palindrome from './Palindrome';
import ChatAI from './ChatAI';
import Text from '../shared-components/Text';

function Projects() {
  return (
    <div className={styles.Projects}>
      <Title className={styles.title} title="AI Chatbot Project" />

      <Text
        text={`
        Below is an AI chat assistant I created that tells you why I am a good
        hire. Feel free to ask it questions about me!`}
      />

      <ChatAI />
      <Title className={styles.title} title="A Fun Palindrome Backend" />

      <Text
        text={`
        It finds if a word is a Pallindrome, i.e. if a word is written the same
        forward and back. Like racecar! See if you can find a word no one has
        found before!`}
      />

      <Text
        text={`
        I setup a serverless backend api-gateway with a lambda keeping track of
        palindromes found with Dynamodb. The backend infrastructure is deployed
        to AWS using Terraform.`}
      />
      <Palindrome />
    </div>
  );
}

export default Projects;
